import React, {useEffect, useState} from 'react';
import {Alert, Col, Form, Input, Modal, notification, Row} from 'antd';
import './index.less';
import AjaxService from "../../Services/AjaxService";

function RegionModal(props: any) {

    const [form] = Form.useForm();

    const [modalState, setModalState] = useState({
        loading: false,
        error: '',
        search: ''
    });

    useEffect(() => {
        if (props.current) {
            form.setFieldsValue(props.current);
        }
    }, [props, form])

    const addRegion = async (values: any) => {
        setModalState((previous: any) => {
            return {
                ...previous,
                error: '',
                loading: true
            };
        });

        try {
            let response = await AjaxService.post('regions', values);
            props.onAdd(response.data);
            closeModal();
        } catch (e: any) {
            if (!('title' in e.data.errors)) {
                notification.error({
                    message: 'Add Region',
                    description: 'There was an issue adding the region. Please try again.'
                });
            }
            setModalState((previous: any) => {
                return {
                    ...previous,
                    error: ('title' in e.data.errors ? e.data.errors.title[0] : ''),
                    loading: false
                };
            });
        }
    }

    const editRegion = async (values: any) => {
        setModalState((previous: any) => {
            return {
                ...previous,
                error: '',
                loading: true
            };
        });

        try {
            let response = await AjaxService.put('regions/' + props.current.id, values);
            props.onEdit(response.data);
            closeModal();
        } catch (e: any) {
            if (!('title' in e.data.errors)) {
                notification.error({
                    message: 'Edit Region',
                    description: 'There was an issue editing the region. Please try again.'
                });
            }
            setModalState((previous: any) => {
                return {
                    ...previous,
                    error: ('title' in e.data.errors ? e.data.errors.title[0] : ''),
                    loading: false
                };
            });
        }
    }

    const closeModal = async () => {
        setModalState((previous: any) => {
            return {
                ...previous,
                loading: false
            };
        });
        form.resetFields();
        props.onClose();
    }

    return (
        <>
            <Modal
                visible
                title={props.current ? 'Edit Region' : 'Add Region'}
                onOk={() => form.submit()}
                onCancel={closeModal}
                destroyOnClose
                forceRender
                confirmLoading={modalState.loading}
            >
                <Form
                    form={form}
                    onFinish={(values: any) => {
                        (props.current ? editRegion(values) : addRegion(values));
                    }}
                    layout="vertical"
                >
                    {modalState.error !== '' && (
                        <Alert style={{marginBottom: '1rem'}} message={modalState.error} type="error" showIcon/>
                    )}
                    <Row gutter={16}>
                        <Col span={12}>
                            <Form.Item
                                label="Name"
                                name="title"
                                rules={[{required: true, message: 'Name is required!'}]}
                            >
                                <Input placeholder="Name"/>
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </Modal>
        </>
    );
}

export default RegionModal;